import { lazyRenderWidgetByLoader, projectLoaders } from 'core-components/helpers/lazyLoad'
import { IWidgetSelector } from 'core-components/sitebuilder/models/IWidgetSelector'

projectLoaders['aria/'] = (name: string) => {
  const layoutName = name.split('/').at(-1)
  return import(`aria/components/layout/${layoutName}.tsx`)
}

export const WidgetSelector = (props: IWidgetSelector) => {
  const KbaseWidgetSelector = props.lazyWidgets?.KbaseWidgetSelector
  const DocflowWidgetSelector = props.lazyWidgets?.DocflowWidgetSelector

  const widgetLoaders: Record<string, () => Promise<any>> = {
    'nakb-timeline': () => import('aria/components/widgets/public/home/Timeline'),
    'nakb-home': () => import('aria/components/widgets/public/home/HomePage'),
  }

  const widgetsWithMeta: string[] = []

  if (props.viewModel in widgetLoaders) {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: widgetLoaders[props.viewModel],
      props: { ...props.props },
      loadMeta: widgetsWithMeta.includes(props.viewModel),
    })
  }

  return (
    (KbaseWidgetSelector && KbaseWidgetSelector(props)) ||
    (DocflowWidgetSelector && DocflowWidgetSelector(props)) ||
    null
  )
}
